import { render, staticRenderFns } from "./ImportUserInfo.vue?vue&type=template&id=6106e6bc"
import script from "./ImportUserInfo.vue?vue&type=script&lang=js"
export * from "./ImportUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6106e6bc')) {
      api.createRecord('6106e6bc', component.options)
    } else {
      api.reload('6106e6bc', component.options)
    }
    module.hot.accept("./ImportUserInfo.vue?vue&type=template&id=6106e6bc", function () {
      api.rerender('6106e6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/ImportUserInfo.vue"
export default component.exports